module.exports = __webpack_public_path__ + "img/background.9e96993c.png";